import { useEffect } from "react";

/**
 * Une session qui glisse (decision 11 du plan, ticket 3 du TCG). Sans cette lecture une session durerait 90 jours fermes depuis sa
 * creation, la regie comprise : la lecture de session de l'app (`session.ts`) et celle de « Mes donnees » ne renouvellent jamais,
 * parce qu'elles n'ont pas de reponse ou poser le cookie. `GET /api/auth/get-session`, elle, repousse l'echeance (la premiere
 * lecture due, une session de plus d'un jour) et pose un cookie neuf. Le site l'appelle donc **une fois a l'ouverture**, du site comme
 * de la regie, par n'importe quelle page de l'app (`routes.tsx` y met le composant de chaque route sauf les pages nues d'OBS).
 *
 * « Une fois » est par chargement du site : une navigation d'une page a l'autre ne la redemande pas. `vu_le` du viewer avance de
 * son cote, par le crochet du plugin (`session.update.after`).
 */
let dejaFait = false;

/**
 * La lecture qui fait glisser la session : `GET /api/auth/get-session` repousse l'echeance de 90 jours (la premiere lecture due) et
 * pose un cookie neuf. La reponse ne sert a rien ici, et une panne ne change rien : la session glissera a la prochaine ouverture.
 */
export async function rafraichirLaSession(): Promise<void> {
  try {
    const reponse = await fetch("/api/auth/get-session", {
      headers: { accept: "application/json" },
      cache: "no-store",
    });
    void reponse.body?.cancel().catch(() => undefined);
  } catch {
    // Rien a faire.
  }
}

/** Pour les tests : le prochain montage rappelle `get-session`. */
export function oublierLeGlissement(): void {
  dejaFait = false;
}

export function useSessionGlissante(): void {
  useEffect(() => {
    if (dejaFait) return;
    dejaFait = true;
    void rafraichirLaSession();
  }, []);
}
